module.exports = __webpack_public_path__ + "static/media/CancelarModal.5c445336.svg";